import React, { useEffect, useState } from 'react';
import { Notification } from 'elmo-elements';
import { useDispatch, useSelector } from 'react-redux';
import { FlashMessages, Message } from './types';
import { actions as flashMessageActions } from '@/modules/reducers/flashMessage';

const MessageRemoveTimer = 1000;
const MessageDismissTimer = 5000;

const FlashMessage = () => {
  const flashMessages: FlashMessages = useSelector(
    (state: { flashMessages: FlashMessages }) => state.flashMessages,
  );

  const [currentMessage, setCurrentMessage] = useState<Message>({});

  const dispatch = useDispatch();

  function setupDismiss(message: Message) {
    dispatch({
      type: flashMessageActions.dismissFlashMessage,
      payload: message,
    });
    setTimeout(
      () =>
        dispatch({
          type: flashMessageActions.removeFlashMessage,
          payload: message,
        }),
      MessageRemoveTimer,
    );
  }

  useEffect(() => {
    const message: any = [...flashMessages.messages].shift();

    if (message) {
      if (currentMessage && message.id === currentMessage.id) {
        if (currentMessage.isActive !== message.isActive) {
          setCurrentMessage(message);
        }
      } else {
        setTimeout(() => setupDismiss(message), MessageDismissTimer);
        setCurrentMessage(message);
      }
    }

    if (
      flashMessages.messages.length === 0 &&
      Object.keys(currentMessage).length !== 0
    ) {
      setCurrentMessage({});
    }
  }, [flashMessages]);

  if (Object.keys(currentMessage).length !== 0) {
    return (
      <div key={currentMessage.id} className={currentMessage.className}>
        <Notification
          isActive={currentMessage.isActive}
          message={currentMessage.message}
          onClose={() => {
            setupDismiss(currentMessage);
          }}
        />
      </div>
    );
  }
  return <div />;
};

export default FlashMessage;
